if (!customElements.get('arw-cart-extras')) {
  let cartExtraBusy = false;
  customElements.define('arw-cart-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('submit', event => this.add(event));
    }

    async add(event) {
      const form = event.target.closest('[data-arw-extra-form]');
      if (!form) return;
      event.preventDefault();
      if (cartExtraBusy || !form.reportValidity()) return;
      cartExtraBusy = true;
      const button = form.querySelector('button[type="submit"]');
      const originalLabel = button.textContent;
      const status = this.querySelector('[role="status"]');
      const addedMessage = this.dataset.added;
      const controls = Array.from(document.querySelectorAll('[data-arw-extra-form] button, button[name="checkout"]')).map(element => [element, element.disabled]);
      controls.forEach(([element]) => element.disabled = true);
      this.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.adding;
      status.textContent = '';
      const cartItems = document.querySelector('cart-items');
      const notification = this.closest('cart-notification');
      const drawer = this.closest('cart-drawer');
      const display = notification || drawer;
      const sections = cartItems && !display ? cartItems.getSectionsToRender() : display?.getSectionsToRender();
      let added = false;
      try {
        const data = new FormData(form);
        if (sections) {
          data.set('sections', sections.map(section => section.section || section.id).join(','));
          data.set('sections_url', window.location.pathname);
        }
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          status.textContent = result.description || this.dataset.error;
          return;
        }
        added = true;
        if (display) {
          display.renderContents(result);
          const refreshed = display.querySelector('arw-cart-extras');
          if (refreshed) refreshed.querySelector('[role="status"]').textContent = addedMessage;
        } else if (cartItems && sections) {
          const replacements = sections.map(section => {
            const html = result.sections?.[section.section || section.id];
            const container = document.getElementById(section.id);
            const target = container?.querySelector(section.selector) || container;
            const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
            if (!target || !source) throw new Error('Cart refresh unavailable');
            return [target, source.innerHTML];
          });
          replacements.forEach(([target, html]) => target.innerHTML = html);
          const refreshed = document.querySelector('#arw-cart-extras-cart arw-cart-extras');
          if (refreshed) {
            refreshed.querySelector('[role="status"]').textContent = addedMessage;
            refreshed.querySelector('button')?.focus({preventScroll: true});
          }
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: result});
        } else {
          window.location.assign(window.routes.cart_url);
        }
      } catch (_) {
        if (added) window.location.assign(window.routes.cart_url);
        else status.textContent = this.dataset.error;
      } finally {
        cartExtraBusy = false;
        controls.forEach(([element, disabled]) => element.disabled = disabled);
        this.removeAttribute('aria-busy');
        button.textContent = originalLabel;
      }
    }
  });
}
